import { DiscountInfoDTO, PricingTierInfoDTO } from 'api-models'
import { ApiClient } from '../api-client'

async function getPricingPlans(): Promise<Array<PricingTierInfoDTO>> {
	const { data } = await ApiClient.client.get('/system/clickguard/plans')
	return data.data
}

async function getCoupon(
	code: string,
	options?: {
		billing_period?: string
		interval?: string
		interval_count?: number
		account_id?: string
	}
): Promise<DiscountInfoDTO> {
	const params = new URLSearchParams()
	if (options?.billing_period) {
		params.append('billing_period', options.billing_period)
	}
	if (options?.interval) {
		params.append('interval', options.interval)
	}
	if (options?.interval_count) {
		params.append('interval_count', options.interval_count.toString())
	}
	if (options?.account_id) {
		params.append('account_id', options.account_id)
	}

	const queryString = params.toString()
	const url = `/system/coupons/${code}${queryString ? `?${queryString}` : ''}`
	const { data } = await ApiClient.client.get(url)
	return data.data
}

export const System = {
	getPricingPlans,
	getCoupon
}
